module.exports = __webpack_public_path__ + "img/i_o_my_store.6486f052.svg";